import type { ReactNode } from "react";

interface BulkActionsToolbarProps {
  selectedCount: number;
  children: ReactNode;
}

export function DataTableBulkActionsToolbar({ selectedCount, children }: BulkActionsToolbarProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <span>{selectedCount} selected</span>
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}
